import { render, staticRenderFns } from "./VideoLink.vue?vue&type=template&id=94d45570&scoped=true&"
import script from "./VideoLink.vue?vue&type=script&lang=js&"
export * from "./VideoLink.vue?vue&type=script&lang=js&"
import style0 from "./VideoLink.vue?vue&type=style&index=0&id=94d45570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d45570",
  null
  
)

export default component.exports